import { z } from 'zod';
import { estado, opcional, uuid } from './comunes.js';
/**
 * LOG-FT-01 — Requerimiento de Materiales, Equipos y Servicios.
 * Encabezado real en la fila 7 de la plantilla; 23 líneas de detalle.
 */
export const requerimientoItemEntrada = z.object({
    itemNumero: z.number().int().min(1).max(999),
    cantidad: z.number().positive('La cantidad debe ser mayor a cero').max(99_999_999),
    unidadId: z.number().int().positive('Elija una unidad'),
    codPartida: opcional(z.string().trim().max(30)),
    insumoId: opcional(z.number().int().positive()),
    insumoServicio: z.string().trim().min(3, 'Describa el insumo o servicio').max(2000),
    descripcionMarca: opcional(z.string().trim().max(2000)),
    lugarDeUso: opcional(z.string().trim().max(150)),
});
export const requerimientoEntrada = z.object({
    empresaId: z.number().int().positive('Elija la empresa emisora'),
    // Editable: el sistema propone el siguiente, el usuario puede cambiarlo.
    correlativo: z.number().int().min(1, 'El correlativo debe ser mayor a cero').max(999_999),
    fechaEmision: z.iso.date(),
    obraId: opcional(z.number().int().positive()),
    areaId: opcional(z.number().int().positive()),
    fechaMaximaAtencion: opcional(z.iso.date()),
    observaciones: opcional(z.string().trim().max(2000)),
    items: z
        .array(requerimientoItemEntrada)
        .min(1, 'Agregue al menos un ítem')
        .max(200),
});
export const requerimientoEdicion = requerimientoEntrada.partial();
export const requerimientoItem = z.object({
    id: z.number().int(),
    itemNumero: z.number().int(),
    cantidad: z.number(),
    unidadId: z.number().int(),
    unidadCodigo: z.string().nullable(),
    codPartida: z.string().nullable(),
    insumoId: z.number().int().nullable(),
    insumoServicio: z.string(),
    descripcionMarca: z.string().nullable(),
    lugarDeUso: z.string().nullable(),
});
/** Fila del listado: sin ítems, para que la tabla no cargue de más. */
export const requerimientoResumen = z.object({
    id: uuid,
    numero: z.string(),
    estado,
    fechaEmision: z.string(),
    fechaMaximaAtencion: z.string().nullable(),
    empresa: z.string(),
    obra: z.string().nullable(),
    area: z.string().nullable(),
    totalItems: z.number().int(),
    emitidoPor: z.string().nullable(),
});
export const requerimiento = requerimientoResumen.extend({
    empresaId: z.number().int(),
    correlativo: z.number().int(),
    obraId: z.number().int().nullable(),
    areaId: z.number().int().nullable(),
    observaciones: z.string().nullable(),
    items: z.array(requerimientoItem),
});
//# sourceMappingURL=requerimiento.js.map